/**
 * Maps the canonical English error strings the optimizer pipeline
 * throws to Portuguese sentences friendly enough for a toast. Anything
 * unrecognised falls through unchanged — we'd rather surface a weird
 * raw message than silently hide an unexpected failure mode.
 *
 * The source-of-truth list of mapped strings:
 *   - "Optimization cycle already in progress." (POST /start, 409)
 *   - "staged proposals" substring in 409 bodies (POST /start)
 *   - "ENOENT" / "no such file" / "calibration.tsv" (corpus missing on disk)
 *   - "Nothing accepted" (POST /commit, 400)
 *   - "No optimization cycle" (POST /commit, 400)
 */
const RULES: { match: RegExp; friendly: string }[] = [
  {
    match: /already in progress/i,
    friendly: "Já tem um ciclo de otimização rodando.",
  },
  {
    match: /staged proposals/i,
    friendly:
      "Há propostas de um ciclo anterior aguardando — commitar ou cancelar antes de iniciar outro.",
  },
  {
    match: /no such file|ENOENT|calibration\.tsv/i,
    friendly:
      "Corpus de calibração indisponível no disco. Restaure um snapshot recente em “Backup / restore das tabelas do labs” ou rode a calibração para popular o corpus no banco.",
  },
  {
    match: /Nothing accepted/i,
    friendly:
      "Nenhuma rubrica foi aceita ainda. Selecione pelo menos uma proposta antes de commitar.",
  },
  {
    match: /No optimization cycle/i,
    friendly: "Não há nenhum ciclo ativo para commitar.",
  },
];

export function friendlyOptimizerError(raw: string): string {
  for (const { match, friendly } of RULES) {
    if (match.test(raw)) return friendly;
  }
  return raw;
}
